
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import authCookie from 'utils/authCookie';
import dynamic from 'next/dynamic';
import Terms from 'constants/contents/terms';

const UserArticleLayout = dynamic(
  () => import('features/static/UserArticleLayout'),
);

const ArticleLayout = dynamic(() => import('features/static/ArticleLayout'));

interface TermsPageProps {
  isLoggedIn: boolean;
}

const TermsPage = ({ isLoggedIn }: TermsPageProps) => {
  if (isLoggedIn) {
    return <UserArticleLayout source={<Terms />} title="Terms" />;
  }

  return <ArticleLayout source={<Terms />} title="Terms" />;
};

export async function getServerSideProps(context) {
  const isLoggedIn = Boolean(authCookie.getIsLoggedIn(context));

  return {
    props: {
      isLoggedIn,
    },
  };
}

export default TermsPage;
